var Vue;

Vue = require('vue');

Vue.use(require('vue-events')["default"]);

Vue.use(require('vue-moment'));

Vue.use(require('vue2-filters'));

module.exports = Vue;

